module.exports = __webpack_public_path__ + "static/media/canvas.702da7ac.jpg";